// extracted by extract-css-chunks-webpack-plugin
module.exports = {"respond":"Respond__respond--3ox1u","response":"Respond__response--1uAXy"};